import React from "react";
import style from "./EmptyQuote.module.css";

export default function FeatEmptyQuote() {
  return (
    <div className={style.root}>
      <p>You have no items in your quote.</p>
    </div>
  );
}

